/* eslint-disable radix */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import CommonApiService from '../../../services/CommonApiService';
import ToastifyService from '../../../services/ToastifyService';
import UrlService from '../../../services/UrlService';
import { usePartnerStockDistribution } from './ContextAPI';
import RequisitionTable from './RequisitionTable';
import LoaderSubmit from '../../LoaderSubmit';
import { reload } from '../../../Utils';

export default function FormInfo() {
    const { setFormShow, rowData, receiveData, setReceiveData, receiveList } =
        usePartnerStockDistribution();
    const { drugCategory, getDrugCategory } = CommonApiService();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    // const [transports, setTransports] = useState([]);

    // console.log(rowData?.records);

    useEffect(() => {
        rowData?.records?.map((el) => {
            const itemdata = {};
            itemdata.drug_id = el.drug_id;
            itemdata.drug_name = el.drug_name;
            itemdata.d1_details_id = el.d1_details_id;
            itemdata.available_qty = el.available_qty;
            itemdata.approved_request_qty = el.approved_request_qty;
            // itemdata.supplied_qty = el.approved_request_qty > 0 ? el.approved_request_qty : el.supplied_qty;
            itemdata.supplied_qty =
                Number(el.available_qty) > Number(el.approved_request_qty)
                    ? el.approved_request_qty
                    : el.available_qty;

            const list = receiveData;
            list[itemdata.drug_id] = itemdata;
            if (itemdata.drug_id === '') {
                delete list[itemdata.drug_id];
            }

            setReceiveData(list);

            return receiveData;
        });
    }, [rowData.records]);

    const axiosPrivate = useAxiosPrivate();

    const {
        register,
        formState: { errors },
        reset,
        handleSubmit,
        setValue,
    } = useForm({
        mode: 'onTouched',
        criteriaMode: 'firstError',
        reValidateMode: 'onBlur',
    });

    // Set default values
    useEffect(() => {
        if (!isEmpty(receiveList)) {
            setValue('requisition', receiveList);
        }
    }, [receiveList]);

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <RequisitionTable
                    id={item.id}
                    data={rowData?.records?.filter((el) => el.category_id == item.id)}
                />
            </Tab>
        ));

    // Form Submit Handelar
    const formSubmitHandler = async (data) => {
        const formData = {
            ...data,
            distribution_type_id: rowData.d1_master_id,
            distribution_type: 'd1',
            // partner_id: rowData.partner_id,
            // central_warehouse_id: rowData.central_warehouse_id,
            transports: [
                { transporter: data.transporter, vehicle_no: data.vehicle_no, driver: data.driver },
            ],
        };

        try {
            const response = await axiosPrivate.post(
                UrlService.partnerStockOut(),
                JSON.stringify(formData),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response?.data?.status === 'error') {
                setIsSubmitted(false);
                ToastifyService.dbErrorNotify(response?.data?.message);
            } else {
                setIsSubmitted(true);
                ToastifyService.updateNotify('Stock Distribution Successfull');
                setFormShow(false);
                reset();
                reload();
            }
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Stock Distribution Failed!');
            }
        }
    };

    const handleClose = () => {
        setFormShow(false);
    };

    register('requisition', { required: 'Requisition quantity is required!' });

    return (
        <Card>
            <Card.Header className="cardHeader">
                <h3>Partner Stock Distribution</h3>
                <div>
                    <Button onClick={() => handleClose()} className="btnInfo" variant="primary">
                        Back to List
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Table bordered size="sm">
                            <thead className="table-light">
                                <tr>
                                    <th>Facility Name</th>
                                    <th>Month</th>
                                    <th>Year</th>
                                </tr>
                            </thead>
                            <tbody className="dark-light-bg">
                                <tr>
                                    <td>{rowData?.facility_name}</td>
                                    <td>{rowData?.month}</td>
                                    <td>{rowData?.year}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <fieldset className="customFieldset dark-light-bg p-4 mb-4">
                    <Row>
                        <Col lg={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Transporter</Form.Label>
                                <Form.Control
                                    name="transporter"
                                    id="transporter"
                                    type="text"
                                    placeholder=""
                                    autoComplete="off"
                                    {...register('transporter', {
                                        required: 'Field is required!',
                                    })}
                                    className={errors?.transporter && 'invalidInput'}
                                />
                                {errors.transporter && (
                                    <span className="invalid">{errors.transporter?.message}</span>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} className="pe-1">
                            <Form.Group className="mb-3">
                                <Form.Label className="pe-5">Vehicle No</Form.Label>
                                <Form.Control
                                    name="vehicle_no"
                                    id="vehicle_no"
                                    type="text"
                                    placeholder=""
                                    autoComplete="off"
                                    {...register('vehicle_no', {
                                        required: 'Field is required!',
                                    })}
                                    className={errors?.vehicle_no && 'invalidInput'}
                                />
                                {errors.vehicle_no && (
                                    <span className="invalid">{errors.vehicle_no?.message}</span>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} className="pe-1">
                            <Form.Group className="mb-3">
                                <Form.Label className="pe-5">Driver</Form.Label>
                                <Form.Control
                                    name="driver"
                                    id="driver"
                                    type="text"
                                    placeholder=""
                                    autoComplete="off"
                                    {...register('driver')}
                                    className={errors?.driver && 'invalidInput'}
                                />
                                {errors.driver && (
                                    <span className="invalid">{errors.driver?.message}</span>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </fieldset>
                <Row>
                    <Tabs
                        activeKey={page}
                        transition={false}
                        id="noanim-tab-example"
                        className="mb-3 ps-3"
                        onSelect={(k) => setPage(parseInt(k))}
                    >
                        {tableDataDisplay()}
                    </Tabs>
                </Row>

                {errors.requisition && (
                    <span className="invalid">{errors.requisition?.message}</span>
                )}

                <div className="formFooter">
                    <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        className="btnInfo me-2 ms-2"
                        variant="primary"
                        style={{ minWidth: '6rem' }}
                        disabled={page === 0}
                        onClick={() => {
                            setPage((currPage) => currPage - 1);
                        }}
                    >
                        Prev
                    </Button>
                    <Button
                        type="button"
                        className={`btnSuccess ${page === pageLength - 1 && 'd-none'}`}
                        variant="success"
                        style={{ minWidth: '6rem' }}
                        onClick={() => setPage((currPage) => currPage + 1)}
                    >
                        Next
                    </Button>

                    <Button
                        onClick={handleSubmit(formSubmitHandler)}
                        className={`btnSuccess ${page !== pageLength - 1 && 'd-none'}`}
                        type="button"
                        variant="success"
                        style={{ minWidth: '6rem' }}
                        disabled={isSubmitted}
                    >
                        Distribution
                    </Button>
                    {isSubmitted && <LoaderSubmit />}
                </div>
            </Card.Body>
        </Card>
    );
}
